import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function onlyLettersNumbersHyphensValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return null; // Si está vacío, no valida error (dejás que el required lo maneje)
        }

        const regex = /^[a-zA-Z0-9-]+$/;

        return regex.test(value) ? null : { invalidAliasFormat: true };
    };
}
